<script setup lang="ts">
import { CustomNuxtLink } from '@gro-up/ui'

import Typography from '../../../../../packages/ui/src/primitives/Typography/Typography.vue'

export type TabsProps = {
  tabs: {
    domain?: string | null
    external?: boolean
    title: string
    url: string
    openInNewTab?: boolean
    currentPage?: boolean
  }[]
}

const { tabs } = defineProps<TabsProps>()
</script>

<template>
  <div class="bg-head-office-40 rounded-lg p-1">
    <ul class="flex gap-1">
      <li v-for="(tab, index) in tabs" :key="`tab-${index}`">
        <CustomNuxtLink
          :to="tab.url"
          class="block px-2 py-2 lg:px-4 lg:py-2 text-center rounded-lg hover:bg-white/50 transition-colors duration-200"
          :class="{ 'bg-white cursor-auto': tab.currentPage === true }">
          <Typography as="span" variant="caption-bold" class="text-primary-100 font-bold">
            {{ tab.title }}
          </Typography>
        </CustomNuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped></style>
